import { render, staticRenderFns } from "./FacebookPagePosts.vue?vue&type=template&id=be0a15aa"
import script from "./FacebookPagePosts.vue?vue&type=script&lang=js"
export * from "./FacebookPagePosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports